import { createGet, createPut, createPost, createDelete } from './fetch';

export const fetchAccount = createGet({
  path: '/api/v1/accounts/me',
});

export const logUserIn = createPost({
  path: '/api/v1/session',
  allowedParams: ['account', 'remember_me'],
  json: true,
});

export const logUserOut = createDelete({
  path: '/api/v1/session',
});

export const signUp = createPost({
  path: '/api/v1/accounts',
  allowedParams: ['account', 'email_address'],
  json: true,
});

export const resetPassword = createPost({
  path: '/api/v1/password_resets',
  allowedParams: ['email_address'],
  json: true,
});

export const fetchNotifications = createGet({
  path: '/api/v1/accounts/current/notifications',
});

export const notificationsRead = createPut({
  path: '/api/v1/accounts/current/notifications',
});
